module.exports = __webpack_public_path__ + "img/130.e310f50b.png";